export default "__VITE_ASSET__Bnci979r__"